import ApiAdmin from "@/services/apiAdmin.service";
import { object } from "@/common/object.util";
import {
  FETCH_ALL,
  FETCH,
  FETCH_LINE_CHART,
  FETCH_ORIGENS,
  CLEAR_ALL,
  FETCH_ALL_PDF
} from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  SET_ALL,
  UNSET_ALL,
  FETCH_ALL_END,
  FETCH_LINE_CHART_END,
  FETCH_LINE_CHART_START,
  SET_LINE_CHART,
  SET_ORIGENS,
  FETCH_START,
  SET,
  FETCH_END,
  FETCH_ALL_PDF_START,
  FETCH_ALL_PDF_END
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  accessControls: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  },
  lineChart: {
    data: []
  },
  origens: [],
  relatorio: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  }
});

const state = {
  accessControls: object.clone(defaults.accessControls),
  relatorio: object.clone(defaults.relatorio),
  lineChart: object.clone(defaults.lineChart),
  origens: object.clone(defaults.origens),
  isFetchingAccessControls: false,
  isFetchingLineChart: false,
  isFetchingRelatorio: false,
  isFetchingPdf: false
};

const getters = {
  lineChart(state) {
    return state.lineChart;
  },
  origens(state) {
    return state.origens;
  },
  relatorio(state) {
    return state.relatorio;
  },
  isFetchingLineChart(state) {
    return state.isFetchingLineChart;
  },
  accessControls(state) {
    return state.accessControls;
  },
  isFetchingAccessControls(state) {
    return state.isFetchingAccessControls;
  },
  isFetchingRelatorio(state) {
    return state.isFetchingRelatorio;
  },
  isFetchingPdf(state) {
    return state.isFetchingPdf;
  }
};

const actions = {
  /**
   * Origens do cliente, sozinhas. Serve o seletor da tela antes de existir
   * relatório — a rota é a mesma escolha do line chart.
   */
  [FETCH_ORIGENS](context, params) {
    const rota = params.isAccessOrganization
      ? "access-controls/reports/superuser/origens"
      : "access-controls/reports/origens";

    return ApiAdmin.query(rota, params)
      .then(response => {
        context.commit(SET_ORIGENS, response.data.origensDisponiveis || []);
      })
      .catch(() => {
        context.commit(SET_ORIGENS, []);
      });
  },
  [FETCH_LINE_CHART](context, params) {
    return new Promise((resolve, reject) => {
      if (!params.isBtnBuscar) {
        return;
      }
      context.commit(FETCH_LINE_CHART_START);

      if (!params.isAccessOrganization) {
        ApiAdmin.query("access-controls/reports/line", params)
          .then(response => {
            context.commit(SET_LINE_CHART, response.data);
            resolve();
          })
          .catch(e => {
            reject(e.response.data);
          })
          .finally(() => {
            context.commit(FETCH_LINE_CHART_END);
          });
      } else {
        ApiAdmin.query("access-controls/reports/superuser/line", params)
          .then(response => {
            context.commit(SET_LINE_CHART, response.data);
            resolve();
          })
          .catch(e => {
            reject(e.response.data);
          })
          .finally(() => {
            context.commit(FETCH_LINE_CHART_END);
          });
      }
    });
  },
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      if (!params.isAccessOrganization) {
        ApiAdmin.query("access-controls/reports/list", params)
          .then(response => {
            context.commit(SET_ALL, response.data);
            resolve(response.data);
          })
          .catch(e => {
            reject(e.response.data);
          })
          .finally(() => {
            context.commit(FETCH_ALL_END);
          });
      } else {
        ApiAdmin.query("access-controls/reports/superuser/list", params)
          .then(response => {
            context.commit(SET_ALL, response.data);
            resolve(response.data);
          })
          .catch(e => {
            reject(e.response.data);
          })
          .finally(() => {
            context.commit(FETCH_ALL_END);
          });
      }
    });
  },
  [FETCH](context, params) {
    return new Promise((resolve, reject) => {
      if (!params) {
        resolve();
        return;
      }
      context.commit(FETCH_START);

      ApiAdmin.query("access-controls/relatorio/get", params)
        .then(response => {
          context.commit(SET, response.data);
        })
        .catch(e => {
          console.log(e);
          reject(false);
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  },
  [CLEAR_ALL](context) {
    return new Promise(resolve => {
      context.commit(UNSET_ALL);
      resolve();
    });
  },
  [FETCH_ALL_PDF](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_PDF_START);

      ApiAdmin.getPdf("access-controls/reports/list", params)
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          var url = window.URL.createObjectURL(blob);

          var anchor = document.createElement("a");
          anchor.href = url;
          var date = new Date().toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
          anchor.download = `EaDStock - Listagem de acessos ${date}`;
          anchor.click();
          resolve();
        })
        .catch(e => {
          console.log(e);

          reject(e.response);
        })
        .finally(() => {
          context.commit(FETCH_ALL_PDF_END);
        });
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingAccessControls = true;
  },
  [SET_ALL](state, accessControls) {
    state.accessControls = accessControls;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingAccessControls = false;
  },
  [FETCH_LINE_CHART_START](state) {
    state.isFetchingLineChart = true;
  },
  [SET_ORIGENS](state, origens) {
    state.origens = origens;
  },
  [SET_LINE_CHART](state, lineChart) {
    state.lineChart.data = lineChart;
  },
  [FETCH_LINE_CHART_END](state) {
    state.isFetchingLineChart = false;
  },
  [UNSET_ALL](state) {
    state.accessControls = object.clone(defaults.accessControls);
    state.origens = object.clone(defaults.origens);
  },
  [FETCH_START](state) {
    state.isFetchingRelatorio = true;
  },
  [SET](state, relatorio) {
    state.relatorio = relatorio;
  },
  [FETCH_END](state) {
    state.isFetchingRelatorio = false;
  },
  [FETCH_ALL_PDF_START](state) {
    state.isFetchingPdf = true;
  },
  [FETCH_ALL_PDF_END](state) {
    state.isFetchingPdf = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
